import api from "utils/axios";

export async function getAdmins() {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/users/get-admins`);
    if (data.success !== true) {
      throw new Error(data.message || "Admins retrieval failed");
    }
    return data.data;
  } catch (error) {
    console.error("admins", error);
    return [];
  }
}

export async function getUsers(page = 1, limit = 10, searchTerm = "", roleFilter="all", sortBy) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/users/get-users`, {
      params: { page, limit, searchTerm, roleFilter, sortBy },
    });
    if (!data || data.success !== true || !data.data) {
      throw new Error(data.message || "Users retrieval failed");
    }
    console.log("Fetched users data:", data.data);
    return {
      users: data.data.users || [],
      pagination: data.data.pagination || null,
    };
  } catch (error) {
    console.error("users", error);
    return { users: [], pagination: null };
  }
}

export async function updateUser(userId, userData) {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/users/update-user`,
      {
        userId,
        ...userData,
      }
    );
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to update user");
    }
    return data.data;
  } catch (error) {
    console.error("updateUser error:", error);
    throw error;
  }
}

export async function updateAdmin(adminId, adminData) {
  try {
    const { data } = await api.post(
      `${process.env.REACT_APP_BASE_URL}/users/update-admin`,
      {
        userId: adminId,
        ...adminData,
      }
    );
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to update admin");
    }
    return data.data;
  } catch (error) {
    console.error("updateAdmin error:", error);
    throw error;
  }
}

export async function deleteUser(userId) {
  try {
    const { data } = await api.delete(`${process.env.REACT_APP_BASE_URL}/users/delete/${userId}`);
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to delete user");
    }
    return data;
  } catch (error) {
    console.error("deleteUser error:", error);
    throw error;
  }
}

// Dummy method for getting user by ID
export async function getUserById(userId) {
  try {
    const { data } = await api.get(`${process.env.REACT_APP_BASE_URL}/users/get-user/${userId}`);
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to get user details");
    }
    return data.data;
  } catch (error) {
    console.error("getUserById error:", error);
    throw error;
  }
}

export async function changeUserPlan(userId, planData) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/users/change-plan`, {
      userId,
      planName: planData,
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to change user plan");
    }
    return data.data;
  } catch (error) {
    console.error("changeUserPlan error:", error);
    throw error;
  }
}

// Get plans by user role
export async function getPlansByRole(role) {
  try {
    // Simulate API call delay
    await new Promise((resolve) => setTimeout(resolve, 300));

    const candidatePlans = ["Journey to Join", "Smart Search"];

    const recruiterPlans = [
      "Starter Recruiter",
      "Catch & Keep",
      "Rapid Hire",
      "Recruit & Conquer",
    ];

    const adminPlans = [];

    let plans = [];
    switch (role) {
      case "candidate":
        plans = candidatePlans;
        break;
      case "recruiter":
        plans = recruiterPlans;
        break;
      case "admin":
        plans = adminPlans;
        break;
      default:
        plans = [];
    }

    return {
      success: true,
      data: plans,
      message: "Plans fetched successfully",
    };
  } catch (error) {
    throw new Error("Failed to fetch plans by role");
  }
}

// Dummy method for bulk user operations
export async function bulkUserOperation(operation, userIds) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/users/bulk-operation`, {
      operation,
      userIds,
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to perform bulk operation");
    }
    return data;
  } catch (error) {
    console.error("bulkUserOperation error:", error);
    throw error;
  }
}

// Dummy method for verifying user profile
export async function verifyUserProfile(userId, verified = true) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/users/verify-profile`, {
      userId,
      verified,
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to verify user profile");
    }
    return data;
  } catch (error) {
    console.error("verifyUserProfile error:", error);
    throw error;
  }
}

// Dummy method for blocking/unblocking user
export async function blockUser(userId, blocked = true) {
  try {
    const { data } = await api.post(`${process.env.REACT_APP_BASE_URL}/users/block-user`, {
      userId,
      blocked,
    });
    if (!data || data.success !== true) {
      throw new Error(data.message || "Failed to block/unblock user");
    }
    return data;
  } catch (error) {
    console.error("blockUser error:", error);
    throw error;
  }
}